// Import jQuery and related libraries
import jQuery from 'jquery'
import iziModal from 'izimodal'
window.jQuery = jQuery
window.$ = jQuery
window.$.fn.extend({ iziModal })

import 'selectize'
